import { useDisconnect } from '@reown/appkit/react'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import React from 'react'

export const Route = createFileRoute('/logout-disabled')({
	component: LogoutComponent,
	errorComponent: LogoutErrorComponent,
})

function LogoutComponent() {
	const { disconnect } = useDisconnect()
	const navigate = useNavigate()

	const handleLogout = async () => {
		try {
			await disconnect()
			navigate({
				to: '/',
			})
		} catch (error) {
			alert(
				'Error logging out: ' +
					(error instanceof Error ? error.message : 'Unknown error'),
			)
		}
	}

	React.useEffect(() => {
		handleLogout()
	}, [
		disconnect,
	])

	return (
		<div>
			<p>Logging out...</p>
			<button type="button" onClick={handleLogout}>
				Confirm Logout
			</button>
		</div>
	)
}

function LogoutErrorComponent({ error }: { error: unknown }) {
	return (
		<div>
			<h1>Logout Error</h1>
			<p>{error instanceof Error ? error.message : 'Unknown error'}</p>
		</div>
	)
}
